export default __webpack_public_path__ + "static/cells-18f459de850c15630021fa8637194a9a.jpg";